import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { IframeV4EntryHelperService } from "@modules/iframeV4/services/iframeV4.entryhelper.service";

export const tinRedirectResolver: ResolveFn<null> = (): null => {
	const iframeV4EntryHelperService = inject(IframeV4EntryHelperService);
	iframeV4EntryHelperService.openModal("tin");
	return null;
};
